import { FC } from "react";

interface IFormsMessageProps {
    newChatMessages: number | null;
}

const FormsMessageIndicator: FC<IFormsMessageProps> = (props: IFormsMessageProps): JSX.Element => {
    return (
        <div>
            {props.newChatMessages != null && props.newChatMessages > 0 ? (
                <div style={{ display: "flex", justifyContent: "center", position: "relative", zIndex: 0 }}>
                    <div className="new-form-message-point">{props.newChatMessages}</div>
                    <i className="icon-f icon-MessagesIndicatorIcon have-message-color fs-20" />
                </div>
            ) : (
                <div style={{ display: "flex", justifyContent: "center", position: "relative", zIndex: 0 }}>
                    <i className="icon-f icon-MessagesIndicatorIcon fs-20 " />
                </div>
            )}
        </div>
    );
};

export default FormsMessageIndicator;
